var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('el-image',{staticStyle:{"width":"100%","height":"100%"},attrs:{"fit":"cover","src":_vm.bg}}),_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"content"},[_vm._t("content")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }